/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionDraftFormData } from './PalAuthSubmissionDraftFormData';
import {
    PalAuthSubmissionDraftFormDataFromJSON,
    PalAuthSubmissionDraftFormDataFromJSONTyped,
    PalAuthSubmissionDraftFormDataToJSON,
    PalAuthSubmissionDraftFormDataToJSONTyped,
} from './PalAuthSubmissionDraftFormData';
import type { PalAuthWizardStage } from './PalAuthWizardStage';
import {
    PalAuthWizardStageFromJSON,
    PalAuthWizardStageFromJSONTyped,
    PalAuthWizardStageToJSON,
    PalAuthWizardStageToJSONTyped,
} from './PalAuthWizardStage';
import type { TimExecution } from './TimExecution';
import {
    TimExecutionFromJSON,
    TimExecutionFromJSONTyped,
    TimExecutionToJSON,
    TimExecutionToJSONTyped,
} from './TimExecution';
import type { PalAuthSubmissionLead } from './PalAuthSubmissionLead';
import {
    PalAuthSubmissionLeadFromJSON,
    PalAuthSubmissionLeadFromJSONTyped,
    PalAuthSubmissionLeadToJSON,
    PalAuthSubmissionLeadToJSONTyped,
} from './PalAuthSubmissionLead';
import type { PalAuthSubmissionErrorType } from './PalAuthSubmissionErrorType';
import {
    PalAuthSubmissionErrorTypeFromJSON,
    PalAuthSubmissionErrorTypeFromJSONTyped,
    PalAuthSubmissionErrorTypeToJSON,
    PalAuthSubmissionErrorTypeToJSONTyped,
} from './PalAuthSubmissionErrorType';
import type { PalAuthSubmissionStatusInfo } from './PalAuthSubmissionStatusInfo';
import {
    PalAuthSubmissionStatusInfoFromJSON,
    PalAuthSubmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionStatusInfoToJSON,
    PalAuthSubmissionStatusInfoToJSONTyped,
} from './PalAuthSubmissionStatusInfo';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalAuthSubmissionRemotePatientSearchConfig } from './PalAuthSubmissionRemotePatientSearchConfig';
import {
    PalAuthSubmissionRemotePatientSearchConfigFromJSON,
    PalAuthSubmissionRemotePatientSearchConfigFromJSONTyped,
    PalAuthSubmissionRemotePatientSearchConfigToJSON,
    PalAuthSubmissionRemotePatientSearchConfigToJSONTyped,
} from './PalAuthSubmissionRemotePatientSearchConfig';
import type { PalAuthSubmissionMode } from './PalAuthSubmissionMode';
import {
    PalAuthSubmissionModeFromJSON,
    PalAuthSubmissionModeFromJSONTyped,
    PalAuthSubmissionModeToJSON,
    PalAuthSubmissionModeToJSONTyped,
} from './PalAuthSubmissionMode';
import type { PalAuthPlatformPayorForm } from './PalAuthPlatformPayorForm';
import {
    PalAuthPlatformPayorFormFromJSON,
    PalAuthPlatformPayorFormFromJSONTyped,
    PalAuthPlatformPayorFormToJSON,
    PalAuthPlatformPayorFormToJSONTyped,
} from './PalAuthPlatformPayorForm';
import type { PalAuthSubmissionMetadata } from './PalAuthSubmissionMetadata';
import {
    PalAuthSubmissionMetadataFromJSON,
    PalAuthSubmissionMetadataFromJSONTyped,
    PalAuthSubmissionMetadataToJSON,
    PalAuthSubmissionMetadataToJSONTyped,
} from './PalAuthSubmissionMetadata';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
    PalAuthSubmissionStatusToJSONTyped,
} from './PalAuthSubmissionStatus';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
    PalReauthCaseManagerToJSONTyped,
} from './PalReauthCaseManager';
import type { PalDocumentToSubmit } from './PalDocumentToSubmit';
import {
    PalDocumentToSubmitFromJSON,
    PalDocumentToSubmitFromJSONTyped,
    PalDocumentToSubmitToJSON,
    PalDocumentToSubmitToJSONTyped,
} from './PalDocumentToSubmit';
import type { PalAuthErrorClassification } from './PalAuthErrorClassification';
import {
    PalAuthErrorClassificationFromJSON,
    PalAuthErrorClassificationFromJSONTyped,
    PalAuthErrorClassificationToJSON,
    PalAuthErrorClassificationToJSONTyped,
} from './PalAuthErrorClassification';
import type { PalReauthSubmissionListEntry } from './PalReauthSubmissionListEntry';
import {
    PalReauthSubmissionListEntryFromJSON,
    PalReauthSubmissionListEntryFromJSONTyped,
    PalReauthSubmissionListEntryToJSON,
    PalReauthSubmissionListEntryToJSONTyped,
} from './PalReauthSubmissionListEntry';
import type { PalAuthSubmissionGeneratedDocument } from './PalAuthSubmissionGeneratedDocument';
import {
    PalAuthSubmissionGeneratedDocumentFromJSON,
    PalAuthSubmissionGeneratedDocumentFromJSONTyped,
    PalAuthSubmissionGeneratedDocumentToJSON,
    PalAuthSubmissionGeneratedDocumentToJSONTyped,
} from './PalAuthSubmissionGeneratedDocument';

/**
 * 
 * @export
 * @interface PalAuthSubmission
 */
export interface PalAuthSubmission {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    tim_execution_id?: string;
    /**
     * 
     */
    form_id?: string;
    /**
     * 
     */
    submission_form_data?: { [key: string]: any; };
    /**
     * 
     */
    draft_form_data?: PalAuthSubmissionDraftFormData;
    /**
     * 
     */
    status?: PalAuthSubmissionStatus;
    /**
     * 
     */
    wizard_stage?: PalAuthWizardStage;
    /**
     * 
     */
    submitted_at?: string;
    /**
     * 
     */
    submitted_by_user_id?: string;
    /**
     * 
     */
    is_non_submission_flow?: boolean;
    /**
     * 
     */
    is_oon?: boolean;
    /**
     * 
     */
    submission_mode?: PalAuthSubmissionMode;
    /**
     * 
     */
    auth_platform_form?: PalAuthPlatformPayorForm;
    /**
     * 
     */
    document_extraction_status?: PalAuthSubmissionDocumentExtractionStatusEnum;
    /**
     * Error captured when document extraction reaches the failed state.
     */
    document_extraction_error?: string;
    /**
     * 
     */
    documents_to_submit?: Array<PalDocumentToSubmit>;
    /**
     * Signed S3 URL for the submission document
     */
    submission_document_s3_url?: string;
    /**
     * 
     */
    status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     */
    previous_status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     */
    status_updated_at?: string;
    /**
     * 
     */
    should_sync_remote_status?: boolean;
    /**
     * 
     */
    external_id?: string;
    /**
     * Normalized destination fax number used for eFax submissions.
     */
    destination_fax_number?: string;
    /**
     * Normalized fax number the eFax was sent from. Null when sent from the shared/generic exacare fax number rather than a dedicated eFax inbox number.
     */
    sender_fax_number?: string;
    /**
     * 
     */
    tim_execution?: TimExecution;
    /**
     * 
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    can_revert_status?: boolean;
    /**
     * 
     */
    can_restart?: boolean;
    /**
     * 
     */
    error_type?: PalAuthSubmissionErrorType;
    /**
     * 
     */
    error_classification?: PalAuthErrorClassification;
    /**
     * 
     */
    is_syncing_remote_status?: boolean;
    /**
     * 
     */
    metadata?: PalAuthSubmissionMetadata;
    /**
     * 
     */
    error_details?: string;
    /**
     * ISO timestamp of when the submission document PDF was generated
     */
    submission_document_generated_at?: string;
    /**
     * ISO timestamp of when the document extraction completed
     */
    document_extraction_completed_at?: string;
    /**
     * 
     */
    remote_patient_search_config?: PalAuthSubmissionRemotePatientSearchConfig;
    /**
     * 
     */
    generated_document?: PalAuthSubmissionGeneratedDocument;
    /**
     * 
     */
    lead?: PalAuthSubmissionLead;
    /**
     * Whether the submission already has re-auth cycles associated to it
     */
    has_reauths?: boolean;
    /**
     * Count of carve-outs still awaiting manual submission or cancellation (ScreenerPalCarveOut.needsManualSubmission())
     */
    deferred_carve_outs_count?: number;
    /**
     * ID of the case manager associated with this pre-auth. Provide on update to assign (null clears it).
     */
    case_manager_id?: string | null;
    /**
     * 
     */
    case_manager?: PalReauthCaseManager;
    /**
     * 
     */
    latest_pal_reauth?: PalReauthSubmissionListEntry;
}


/**
 * @export
 */
export const PalAuthSubmissionDocumentExtractionStatusEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed',
} as const;
export type PalAuthSubmissionDocumentExtractionStatusEnum = typeof PalAuthSubmissionDocumentExtractionStatusEnum[keyof typeof PalAuthSubmissionDocumentExtractionStatusEnum];


/**
 * Check if a given object implements the PalAuthSubmission interface.
 */
export function instanceOfPalAuthSubmission(value: object): value is PalAuthSubmission {
    return true;
}

export function PalAuthSubmissionFromJSON(json: any): PalAuthSubmission {
    return PalAuthSubmissionFromJSONTyped(json, false);
}

export function PalAuthSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmission {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tim_execution_id': json['tim_execution_id'] == null ? undefined : json['tim_execution_id'],
        'form_id': json['form_id'] == null ? undefined : json['form_id'],
        'submission_form_data': json['submission_form_data'] == null ? undefined : json['submission_form_data'],
        'draft_form_data': json['draft_form_data'] == null ? undefined : PalAuthSubmissionDraftFormDataFromJSON(json['draft_form_data']),
        'status': json['status'] == null ? undefined : PalAuthSubmissionStatusFromJSON(json['status']),
        'wizard_stage': json['wizard_stage'] == null ? undefined : PalAuthWizardStageFromJSON(json['wizard_stage']),
        'submitted_at': json['submitted_at'] == null ? undefined : json['submitted_at'],
        'submitted_by_user_id': json['submitted_by_user_id'] == null ? undefined : json['submitted_by_user_id'],
        'is_non_submission_flow': json['is_non_submission_flow'] == null ? undefined : json['is_non_submission_flow'],
        'is_oon': json['is_oon'] == null ? undefined : json['is_oon'],
        'submission_mode': json['submission_mode'] == null ? undefined : PalAuthSubmissionModeFromJSON(json['submission_mode']),
        'auth_platform_form': json['auth_platform_form'] == null ? undefined : PalAuthPlatformPayorFormFromJSON(json['auth_platform_form']),
        'document_extraction_status': json['document_extraction_status'] == null ? undefined : json['document_extraction_status'],
        'document_extraction_error': json['document_extraction_error'] == null ? undefined : json['document_extraction_error'],
        'documents_to_submit': json['documents_to_submit'] == null ? undefined : ((json['documents_to_submit'] as Array<any>).map(PalDocumentToSubmitFromJSON)),
        'submission_document_s3_url': json['submission_document_s3_url'] == null ? undefined : json['submission_document_s3_url'],
        'status_info': json['status_info'] == null ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': json['previous_status_info'] == null ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'status_updated_at': json['status_updated_at'] == null ? undefined : json['status_updated_at'],
        'should_sync_remote_status': json['should_sync_remote_status'] == null ? undefined : json['should_sync_remote_status'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
        'destination_fax_number': json['destination_fax_number'] == null ? undefined : json['destination_fax_number'],
        'sender_fax_number': json['sender_fax_number'] == null ? undefined : json['sender_fax_number'],
        'tim_execution': json['tim_execution'] == null ? undefined : TimExecutionFromJSON(json['tim_execution']),
        'status_updated_by_user': json['status_updated_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'can_revert_status': json['can_revert_status'] == null ? undefined : json['can_revert_status'],
        'can_restart': json['can_restart'] == null ? undefined : json['can_restart'],
        'error_type': json['error_type'] == null ? undefined : PalAuthSubmissionErrorTypeFromJSON(json['error_type']),
        'error_classification': json['error_classification'] == null ? undefined : PalAuthErrorClassificationFromJSON(json['error_classification']),
        'is_syncing_remote_status': json['is_syncing_remote_status'] == null ? undefined : json['is_syncing_remote_status'],
        'metadata': json['metadata'] == null ? undefined : PalAuthSubmissionMetadataFromJSON(json['metadata']),
        'error_details': json['error_details'] == null ? undefined : json['error_details'],
        'submission_document_generated_at': json['submission_document_generated_at'] == null ? undefined : json['submission_document_generated_at'],
        'document_extraction_completed_at': json['document_extraction_completed_at'] == null ? undefined : json['document_extraction_completed_at'],
        'remote_patient_search_config': json['remote_patient_search_config'] == null ? undefined : PalAuthSubmissionRemotePatientSearchConfigFromJSON(json['remote_patient_search_config']),
        'generated_document': json['generated_document'] == null ? undefined : PalAuthSubmissionGeneratedDocumentFromJSON(json['generated_document']),
        'lead': json['lead'] == null ? undefined : PalAuthSubmissionLeadFromJSON(json['lead']),
        'has_reauths': json['has_reauths'] == null ? undefined : json['has_reauths'],
        'deferred_carve_outs_count': json['deferred_carve_outs_count'] == null ? undefined : json['deferred_carve_outs_count'],
        'case_manager_id': json['case_manager_id'] === undefined ? undefined : json['case_manager_id'] === null ? null : json['case_manager_id'],
        'case_manager': json['case_manager'] == null ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
        'latest_pal_reauth': json['latest_pal_reauth'] == null ? undefined : PalReauthSubmissionListEntryFromJSON(json['latest_pal_reauth']),
    };
}

export function PalAuthSubmissionToJSON(json: any): PalAuthSubmission {
    return PalAuthSubmissionToJSONTyped(json, false);
}

export function PalAuthSubmissionToJSONTyped(value?: PalAuthSubmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tim_execution_id': value['tim_execution_id'],
        'form_id': value['form_id'],
        'submission_form_data': value['submission_form_data'],
        'draft_form_data': PalAuthSubmissionDraftFormDataToJSON(value['draft_form_data']),
        'status': PalAuthSubmissionStatusToJSON(value['status']),
        'wizard_stage': PalAuthWizardStageToJSON(value['wizard_stage']),
        'submitted_at': value['submitted_at'],
        'submitted_by_user_id': value['submitted_by_user_id'],
        'is_non_submission_flow': value['is_non_submission_flow'],
        'is_oon': value['is_oon'],
        'submission_mode': PalAuthSubmissionModeToJSON(value['submission_mode']),
        'auth_platform_form': PalAuthPlatformPayorFormToJSON(value['auth_platform_form']),
        'document_extraction_status': value['document_extraction_status'],
        'document_extraction_error': value['document_extraction_error'],
        'documents_to_submit': value['documents_to_submit'] == null ? undefined : ((value['documents_to_submit'] as Array<any>).map(PalDocumentToSubmitToJSON)),
        'submission_document_s3_url': value['submission_document_s3_url'],
        'status_info': PalAuthSubmissionStatusInfoToJSON(value['status_info']),
        'previous_status_info': PalAuthSubmissionStatusInfoToJSON(value['previous_status_info']),
        'status_updated_at': value['status_updated_at'],
        'should_sync_remote_status': value['should_sync_remote_status'],
        'external_id': value['external_id'],
        'destination_fax_number': value['destination_fax_number'],
        'sender_fax_number': value['sender_fax_number'],
        'tim_execution': TimExecutionToJSON(value['tim_execution']),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['status_updated_by_user']),
        'can_revert_status': value['can_revert_status'],
        'can_restart': value['can_restart'],
        'error_type': PalAuthSubmissionErrorTypeToJSON(value['error_type']),
        'error_classification': PalAuthErrorClassificationToJSON(value['error_classification']),
        'is_syncing_remote_status': value['is_syncing_remote_status'],
        'metadata': PalAuthSubmissionMetadataToJSON(value['metadata']),
        'error_details': value['error_details'],
        'submission_document_generated_at': value['submission_document_generated_at'],
        'document_extraction_completed_at': value['document_extraction_completed_at'],
        'remote_patient_search_config': PalAuthSubmissionRemotePatientSearchConfigToJSON(value['remote_patient_search_config']),
        'generated_document': PalAuthSubmissionGeneratedDocumentToJSON(value['generated_document']),
        'lead': PalAuthSubmissionLeadToJSON(value['lead']),
        'has_reauths': value['has_reauths'],
        'deferred_carve_outs_count': value['deferred_carve_outs_count'],
        'case_manager_id': value['case_manager_id'],
        'case_manager': PalReauthCaseManagerToJSON(value['case_manager']),
        'latest_pal_reauth': PalReauthSubmissionListEntryToJSON(value['latest_pal_reauth']),
    };
}

